(function ($) {
	const $toggleDesc = $('.toggle__description');

	const $expandDesc = $('#cookie-expand-details');
	const $hideDesc = $('#cookie-hide-details');

	$expandDesc.on('click', function () {
		$toggleDesc.toggle();
		$hideDesc.css('display', 'flex');
		$expandDesc.hide();
	});

	$hideDesc.on('click', function () {
		$toggleDesc.toggle();
		$expandDesc.css('display', 'flex');
		$hideDesc.hide();
	});
})(jQuery);

function createCookie(name, value, days) {
	let expires;

	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toGMTString();
	} else {
		expires = '';
	}
	document.cookie =
		encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
}

function readCookie(name) {
	const nameEQ = encodeURIComponent(name) + '=';
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0) {
			return decodeURIComponent(c.substring(nameEQ.length, c.length));
		}
	}
	return null;
}

(function ($) {
	$.fn.cookies = function () {
		let $el;
		let $manageButton;
		let $acceptButton;
		let $saveButton;
		let $rejectButton;

		let $initialModal;
		let $manageModal;

		let $manageLink;
		const init = function () {
			$initialModal = $el.find('.cookie-banner__initial');
			$manageModal = $el.find('.cookie-banner__manage');

			$manageButton = $el.find('.js-manage');
			$acceptButton = $el.find('#js-accept');
			$saveButton = $el.find('.js-save');
			$rejectButton = $el.find('.js-reject');

			$manageLink = $('a[href="#manage"]');

			if (
				readCookie('views_necessary') === null &&
				window.location.href.indexOf('cookies') === -1
			) {
				$el.show();
			}

			if (readCookie('views_analytics') === 'accepted') {
				$el.find('input[id="analytics"]').prop('checked', true);
			}

			if (readCookie('views_marketing') === 'accepted') {
				$el.find('input[id="marketing"]').prop('checked', true);
			}

			$manageButton.on('click', function (e) {
				e.preventDefault();
				$initialModal.hide();
				$initialModal.addClass('initialized');
				$manageModal.addClass('visible');
			});

			$acceptButton.on('click', function (e) {
				e.preventDefault();

				createCookie('views_necessary', 'accepted', '30');
				createCookie('views_analytics', 'accepted', '30');
				createCookie('views_marketing', 'accepted', '30');

				$el.hide();
			});

			$el.find('input[type="checkbox"]').on('change', function () {
				$saveButton.removeClass('accepted');
				$saveButton.removeClass('analytics');
				$saveButton.removeClass('marketing');
				$saveButton.removeClass('necessary');

				if (
					$el.find('input[name="analytics"]').is(':checked') &&
					$el.find('input[name="marketing"]').is(':checked')
				) {
					$saveButton.addClass('accepted');
				} else if ($el.find('input[name="analytics"]').is(':checked')) {
					$saveButton.addClass('analytics');
				} else if ($el.find('input[name="marketing"]').is(':checked')) {
					$saveButton.addClass('marketing');
				} else {
					$saveButton.addClass('necessary');
				}
			});

			$saveButton.on('click', function (e) {
				e.preventDefault();

				createCookie('views_necessary', 'accepted', '30');
				if ($el.find('input[name="analytics"]').is(':checked')) {
					createCookie('views_analytics', 'accepted', '30');
				} else {
					createCookie('views_analytics', 'rejected', '30');
				}
				if ($el.find('input[name="marketing"]').is(':checked')) {
					createCookie('views_marketing', 'accepted', '30');
				} else {
					createCookie('views_marketing', 'rejected', '30');
				}

				$el.hide();
			});

			$rejectButton.on('click', function (e) {
				e.preventDefault();

				createCookie('views_necessary', 'accepted', '30');
				createCookie('views_analytics', 'rejected', '30');
				createCookie('views_marketing', 'rejected', '30');

				$el.hide();
			});

			$manageLink.on('click', function (e) {
				e.preventDefault();
				$initialModal.hide();
				$manageModal.addClass('visible');
				$el.show();
			});
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).cookies();
				});
			} else {
				$el = this;
				init();
			}
		}
	};
})(jQuery);

(function ($) {
	$(document).ready(function () {
		$('.cookie-banner').cookies();
	});
})(jQuery);
